<template>
  <Confirm ref="confirmRef" :data="data" @callback="rechange">
    <template #content>
      <el-form ref="ruleFormRef" :model="ruleForm" :rules="rules" label-width="120px" class="demo-ruleForm" status-icon>
        <div class="rechange-content">
          <div class="rechange-summary">
            <div class="summary-item">
              <span class="summary-label">当前账号</span>
              <span class="summary-value">{{ userInfo.account_id }}</span>
            </div>
            <div class="summary-item summary-item-right">
              <span class="summary-label">账户余额</span>
              <span class="summary-value summary-balance">￥{{ userInfo.balance }}</span>
            </div>
          </div>

          <el-link class="rechange-link" type="primary">银行转账收款账户</el-link>

          <ul class="rechange-ul">
            <li class="rechange-li" v-for="(item, index) in displayBankInfoList" :key="index">
              <span class="li-value">{{ item }}</span>
            </li>
          </ul>

          <!-- <el-form-item label="充值金额:" prop="money">
                    <el-input v-model="ruleForm.money" placeholder="输入金额"></el-input>
                </el-form-item>
                <el-form-item label="充值方式:" prop="type">
                    <el-select v-model="ruleForm.type" placeholder="选择充值方式">
                        <el-option label="微信" value="微信"></el-option>
                        <el-option label="支付宝" value="支付宝"></el-option>
                    </el-select>
                </el-form-item> -->
          <div class="qr-code-container">
            <div style="width: 100%">
              <img id="qrCodeImg" class="qr_code_img" v-if="store.qrCodeUrl" />
              <div
                class="alert alert-info"
                style="width: 100%; margin: 5px auto; text-align: center"
                v-if="store.qrCodeUrl"
              >
                请使用微信 App 扫描二维码！
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </template>
  </Confirm>
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, computed } from 'vue'
import Confirm from '../../components/Confirm.vue'
import { useCounterStore } from '../../store/userInfo'
import { storeToRefs } from 'pinia'

const confirmRef = ref<any>(null)
const data = {
  title: '充值提示',
  tips: '',
  cancel: '取消',
  confirm: '立即充值',
  footer: true,
  width: '40%'
}
const store = useCounterStore()
const { userInfo } = storeToRefs(store)
const props = defineProps({
  bankInfo: {
    type: String,
    default: ''
  }
})
const parseBankInfo = (raw: string) => {
  const text = String(raw || '')
    .replace(/\\r\\n/g, '\n')
    .replace(/<br\s*\/?>/gi, '\n')

  // 不做任何格式限制/解析：接口返回什么就按行展示什么
  return text.split('\n')
}

const displayBankInfoList = computed(() => parseBankInfo(props.bankInfo))

const ruleFormRef = ref(null)
const ruleForm = reactive({
  money: '',
  type: '微信' // 默认选择支付宝
})

const emit = defineEmits(['closeRechange'])

function rechange(s: any) {
  emit('closeRechange', { ...s, ...ruleForm })
}

const rules = reactive({
  money: [
    {
      required: true,
      message: '请输入充值金额',
      trigger: 'blur'
    }
  ],
  type: [
    {
      required: true,
      message: '请选择充值方式',
      trigger: 'change'
    }
  ]
})

onMounted(function () {
  if (confirmRef.value) confirmRef.value.show()
})
</script>
<style scoped>
.type_image {
  width: 100px;
  height: 35px;
  border: 1px solid #1f96f8;
  text-align: center;
  border-radius: 7px;
}

.type_image img {
  max-width: 80%;
  margin-top: 2px;
}

.rechange-content {
  padding: 0 42px 8px;
}

.rechange-summary {
  display: flex;
  align-items: center;
  gap: 28px;
  padding: 14px 0 10px;
  margin-bottom: 14px;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  margin-top: 15px;
}

.summary-item-right {
  justify-content: flex-end;
}

.summary-label {
  font-weight: 700;
  color: #303133;
  white-space: nowrap;
  font-size: 14px;
}

.summary-value {
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}

.summary-balance {
  font-weight: 700;
}

.rechange-link {
  display: inline-block;
  color: #1f96f8;
  text-decoration: none;
  margin: 4px 0 12px;
  font-weight: 600;
}

.rechange-link:hover {
  text-decoration: underline;
}

.rechange-ul {
  list-style: none;
  padding: 0;
  margin: 0 0 12px;
}

.rechange-li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 4px 0;
  line-height: 1.5;
}

.li-label {
  width: 72px;
  flex: 0 0 72px;
  color: #303133;
  white-space: nowrap;
  text-align: right;
}

.li-value {
  flex: 1 1 auto;
  color: #606266;
  word-break: break-all;
}

.qr_code_img {
  width: 250px;
  height: 250px;
  display: block;
  margin: 10px auto 0;
}

.alert-info {
  --bs-alert-color: #055160;
  --bs-alert-bg: #cff4fc;
  --bs-alert-border-color: #b6effb;
}
</style>
